import { CANONICAL_ALIASES, CANONICAL_NAMES, SYSTEM_ARCHITECTURE } from "./systemArchitecture.mjs";

export class ValidationError extends Error { constructor(message, details = []) { super(message); this.name = "ValidationError"; this.details = details; } }

const DATE = /^\d{4}-\d{2}-\d{2}$/;
const TIME = /^([01]\d|2[0-3]):[0-5]\d$/;
const clean = value => typeof value === "string" ? value.trim() : value;
const BRAND_PATTERN = new RegExp(
  [CANONICAL_NAMES.GREAT_UNLOCKIN, ...CANONICAL_ALIASES[CANONICAL_NAMES.GREAT_UNLOCKIN]]
    .sort((a, b) => b.length - a.length)
    .map(value => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|"),
  "gi"
);

export function resolveCanonicalName(value) {
  if (typeof value !== "string") return value;
  const normalized = value.trim().toLowerCase();
  for (const [canonical, aliases] of Object.entries(CANONICAL_ALIASES)) {
    if (normalized === canonical.toLowerCase() || aliases.some(alias => normalized === alias.toLowerCase())) return canonical;
  }
  return value.trim();
}

export function canonicalizeKnownBrandText(value) {
  if (typeof value !== "string") return value;
  return value.replace(BRAND_PATTERN, CANONICAL_NAMES.GREAT_UNLOCKIN);
}

export function normalizeRecord(recordType, input) {
  const def = SYSTEM_ARCHITECTURE.recordTypes[recordType];
  if (!def) throw new ValidationError(`Unsupported record type: ${recordType}`);
  const out = { ...input };
  for (const key of Object.keys(out)) out[key] = clean(out[key]);
  if (out.id != null) out.id = String(out.id);
  for (const key of ["projectId", "outcomeId", "sourceProposalId", "handoffOperationId"]) if (out[key] != null) out[key] = String(out[key]);
  if (Array.isArray(out.taskIds)) out.taskIds = [...new Set(out.taskIds.map(String))];
  if (recordType === "schedule_block") {
    out.date = out.date || out.scheduleDate || "";
    out.scheduleDate = out.scheduleDate || out.date || "";
  }
  for (const key of ["name", "title", "projectTitle", "outcomeTitle", "details", "notes"]) if (out[key]) out[key] = canonicalizeKnownBrandText(out[key]);
  if (recordType === "task" && out.status === "not-started") out.status = "not started";
  return out;
}

export function validateRecord(recordType, input, { strict = true } = {}) {
  const def = SYSTEM_ARCHITECTURE.recordTypes[recordType];
  if (!def) throw new ValidationError(`Unsupported record type: ${recordType}`);
  const record = normalizeRecord(recordType, input);
  const errors = [];
  for (const required of def.required) if (record[required] == null || record[required] === "") errors.push(`${required} is required`);
  for (const [name, spec] of Object.entries(def.fields)) {
    const value = record[name]; if (value == null || value === "") continue;
    if (spec.type === "string" && typeof value !== "string") errors.push(`${name} must be a string`);
    if (spec.type === "string[]" && (!Array.isArray(value) || value.some(v => typeof v !== "string"))) errors.push(`${name} must be a string array`);
    if (spec.type === "date" && !DATE.test(value)) errors.push(`${name} must be YYYY-MM-DD`);
    if (spec.type === "time" && !TIME.test(value)) errors.push(`${name} must be HH:MM`);
    if (spec.type === "enum" && !spec.values.includes(value)) errors.push(`${name} must be one of: ${spec.values.join(", ")}`);
  }
  if (strict && recordType === "schedule_block" && (!record.taskIds || !record.taskIds.length)) errors.push("taskIds must contain at least one canonical Task ID");
  if (errors.length) throw new ValidationError(`Invalid ${recordType}`, errors);
  return record;
}
